function initRuqyCollection() {
  if (!document.body.classList.contains('collection-ruqy')) return;

  const filtersRoot = document.querySelector('[data-collection-filters]');
  const grid = document.querySelector('[data-collection-grid]');
  const emptyState = document.querySelector('[data-collection-empty]');
  const sortMenu = document.querySelector('[data-collection-sort-menu]');
  const dropdowns = document.querySelectorAll('[data-collection-dropdown]');

  if (!grid) return;

  let currentSort = 'featured';
  const wishlistStorageKey = 'ruqy-wishlist';

  function getWishlist() {
    try {
      const saved = JSON.parse(window.localStorage.getItem(wishlistStorageKey) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(handles) {
    window.localStorage.setItem(wishlistStorageKey, JSON.stringify(handles));
    document.dispatchEvent(new CustomEvent('ruqy:wishlist-change', { detail: { handles } }));
  }

  const getCards = () => grid.querySelectorAll('[data-collection-card]');

  function closeAllDropdowns(except) {
    dropdowns.forEach((dropdown) => {
      if (dropdown === except) return;
      const trigger = dropdown.querySelector('[data-collection-dropdown-trigger]');
      const panel = dropdown.querySelector('.toolbar-dropdown__panel');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
      dropdown.classList.remove('is-open');
    });
  }

  function setFilter(option, stone) {
    if (!filtersRoot) return;

    filtersRoot.querySelectorAll('[data-collection-filter]').forEach((btn) => {
      const isActive = btn === option;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    let visible = 0;
    getCards().forEach((card) => {
      const stones = card.dataset.stones || '';
      const show = stone === 'all' || stones.includes(stone);
      card.classList.toggle('hidden', !show);
      if (show) {
        visible += 1;
        card.style.animation = 'none';
        card.offsetHeight;
        card.style.animation = '';
      }
    });

    if (emptyState) {
      emptyState.classList.toggle('visible', visible === 0);
    }
  }

  function sortCards(value) {
    currentSort = value;
    const items = Array.from(getCards());
    items.sort((a, b) => {
      const pa = parseInt(a.dataset.price, 10) || 0;
      const pb = parseInt(b.dataset.price, 10) || 0;
      if (value === 'price-asc') return pa - pb;
      if (value === 'price-desc') return pb - pa;
      const sa = parseInt(a.dataset.sortOrder, 10) || 0;
      const sb = parseInt(b.dataset.sortOrder, 10) || 0;
      return sa - sb;
    });

    items.forEach((el, i) => {
      el.style.animationDelay = `${i * 60}ms`;
      el.style.animation = 'none';
      el.offsetHeight;
      el.style.animation = '';
      grid.appendChild(el);
    });
  }

  function toggleWishlist(event, btn) {
    event.preventDefault();
    event.stopPropagation();
    const card = btn.closest('[data-collection-card]');
    const handle = card?.dataset.productHandle;
    if (!handle) return;

    const handles = getWishlist();
    const index = handles.indexOf(handle);
    if (index >= 0) {
      handles.splice(index, 1);
    } else {
      handles.push(handle);
    }

    const isActive = handles.includes(handle);
    btn.classList.toggle('active', isActive);
    btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    btn.setAttribute('aria-label', isActive ? 'Remove from likes' : 'Add to likes');
    saveWishlist(handles);
    btn.style.transform = 'scale(1.15)';
    window.setTimeout(() => {
      btn.style.transform = '';
    }, 180);
  }

  function initCarousel(carousel) {
    const slides = carousel.querySelectorAll('[data-carousel-slide]');
    if (slides.length <= 1) return;

    let currentIndex = 0;
    let touchInteraction = false;
    let touchPreviewed = false;
    const nextBtn = carousel.closest('.card-image-wrap')?.querySelector('[data-carousel-next]');

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
      currentIndex = index;
    }

    carousel.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') showSlide(1);
    });

    carousel.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse') showSlide(0);
    });

    carousel.addEventListener('pointerdown', (event) => {
      touchInteraction = event.pointerType === 'touch' || event.pointerType === 'pen';
    });

    carousel.addEventListener('click', (event) => {
      if (!touchInteraction || event.target.closest('button')) return;
      touchInteraction = false;

      if (!touchPreviewed) {
        event.preventDefault();
        event.stopPropagation();
        showSlide(1);
        touchPreviewed = true;
      } else {
        touchPreviewed = false;
      }
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        showSlide((currentIndex + 1) % slides.length);
      });
    }
  }

  dropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector('[data-collection-dropdown-trigger]');
    const panel = dropdown.querySelector('.toolbar-dropdown__panel');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', () => {
      const isOpen = dropdown.classList.contains('is-open');
      closeAllDropdowns();
      if (!isOpen) {
        dropdown.classList.add('is-open');
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-collection-dropdown]')) {
      closeAllDropdowns();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAllDropdowns();
  });

  if (filtersRoot) {
    filtersRoot.querySelectorAll('[data-collection-filter]').forEach((option) => {
      option.addEventListener('click', () => {
        setFilter(option, option.dataset.collectionFilter || 'all');
        closeAllDropdowns();
      });
    });
  }

  if (sortMenu) {
    sortMenu.querySelectorAll('[data-collection-sort-value]').forEach((option) => {
      option.addEventListener('click', () => {
        const value = option.dataset.collectionSortValue || 'featured';
        sortMenu.querySelectorAll('[data-collection-sort-value]').forEach((btn) => {
          const isActive = btn === option;
          btn.classList.toggle('active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        sortCards(value);
        closeAllDropdowns();
      });
    });
  }

  document.querySelectorAll('[data-collection-wishlist]').forEach((btn) => {
    const handle = btn.closest('[data-collection-card]')?.dataset.productHandle;
    const isActive = handle && getWishlist().includes(handle);
    btn.classList.toggle('active', Boolean(isActive));
    btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    btn.setAttribute('aria-label', isActive ? 'Remove from likes' : 'Add to likes');
    btn.addEventListener('click', (event) => toggleWishlist(event, btn));
  });

  document.querySelectorAll('[data-collection-carousel]').forEach(initCarousel);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRuqyCollection);
} else {
  initRuqyCollection();
}
